import { axiosPremmiar, getAccessToken, getParticipantInfo } from '../FocalPoint/Shared/axios'

export const searchCards = async (cpf) => {
  const participantInfos = getParticipantInfo()

  const headers = {
    'Authorization': `Bearer ${getAccessToken()}`,
    'login': `${participantInfos.username}`,
    'campaignId': `${participantInfos['custom:campaign_id']}`,
    'catalogId': `${participantInfos['custom:catalog_id']}`
  }

  return axiosPremmiar
    .get(`v1/focalpoint/searchCard/${cpf}`, { headers })
    .then((res) => {
      return res.data.data
    })
    .catch(() => {
      return 'Não há cartão requisitado para esse cpf'
    })
}

export const pointsToCash = async (points, token) => {
  const participantInfos = getParticipantInfo()

  const headers = {
    'Authorization': `Bearer ${token}`,
    'login': `${participantInfos.username}`,
    'campaignId': `${participantInfos['custom:campaign_id']}`,
    'catalogId': `${participantInfos['custom:catalog_id']}`
  }

  return axiosPremmiar
    .get(`v1/focalpoint/pointsToMiles/${points}`, { headers })
    .then((res) => {
      return res.data.data
    })
    .catch(() => {
      return 'Não foi possivel converter os pontos'
    })
}

export const redemptionCard = async (body, token) => {
  const participantInfos = getParticipantInfo()

  const headers = {
    'Authorization': `Bearer ${token}`,
    'login': `${participantInfos.username}`,
    'campaignId': `${participantInfos['custom:campaign_id']}`,
    'catalogId': `${participantInfos['custom:catalog_id']}`
  }

  return axiosPremmiar
    .post('v1/focalpoint/orders/redemption', body, { headers })
    .then((res) => {
      return res.data.data
    })
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default {
  searchCards,
  pointsToCash,
  redemptionCard
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/LikePlusClientCustom.js